export default "__VITE_ASSET__CZaGwfc4__"